import type { Page } from "@pagelink/shared";
import { PageRow } from "./PageList.tsx";
import { Note } from "./ui.tsx";

/* Pages you starred, newest first. A bookmark, not a workflow state. */
export function Stars({ incoming, outgoing, meId, stars, onStar, onOpen }: {
  incoming: Page[]; outgoing: Page[]; meId: string; stars: Set<string>; onStar: (id: string) => void; onOpen: (id: string) => void;
}) {
  const seen = new Set<string>();
  const list = [...incoming, ...outgoing]
    .filter((p) => stars.has(p.id) && !seen.has(p.id) && seen.add(p.id))
    .sort((a, b) => Date.parse(b.sentAt) - Date.parse(a.sentAt));
  return (
    <>
      <h1 className="screen-title">Stars</h1>
      <p className="screen-sub">Pages you marked to come back to.</p>
      {list.length === 0 ? (
        <Note>Nothing starred. Tap the star on any page card to keep it here.</Note>
      ) : (
        list.map((p) => (
          <PageRow key={p.id} page={p} meId={meId} direction={p.toId === meId ? "in" : "out"}
            onOpen={() => onOpen(p.id)} starred onStar={() => onStar(p.id)} />
        ))
      )}
    </>
  );
}
